import { visit } from "unist-util-visit";

/**
 * Map legacy `align` on elements to utility classes (README-style `<h1 align="center">`).
 * Skip `td`/`th`: JSX runtime converts those to `style` at render time.
 */
const SKIP_TAGS = new Set(["td", "th"]);

const ALIGN_CLASS = {
  left: "markdown-html-align-left",
  center: "markdown-html-align-center",
  right: "markdown-html-align-right",
  justify: "markdown-html-align-justify",
};

function stringifyAlign(value) {
  if (typeof value === "string") return value;
  if (Array.isArray(value) && typeof value[0] === "string") return value[0];
  return undefined;
}

function mergeClassName(existing, added) {
  const parts = new Set();
  const pushTokens = (s) => {
    for (const t of s.trim().split(/\s+/)) {
      if (t) parts.add(t);
    }
  };
  if (Array.isArray(existing)) {
    for (const c of existing) {
      if (typeof c === "string") pushTokens(c);
    }
  } else if (typeof existing === "string") {
    pushTokens(existing);
  }
  parts.add(added);
  return [...parts];
}

export default function rehypeLegacyAlignAsClass() {
  return (tree) => {
    visit(tree, "element", (node) => {
      if (SKIP_TAGS.has(node.tagName)) return;

      const raw = stringifyAlign(node.properties?.align);
      if (!raw) return;

      const key = raw.trim().toLowerCase();
      const cls = ALIGN_CLASS[key];
      if (!cls) return;

      const next = { ...node.properties };
      delete next.align;
      next.className = mergeClassName(next.className, cls);
      node.properties = next;
    });
  };
}
